const validSupplantType = ['string', 'number', 'boolean'];
/**
 * string supplant.只接受string | number | boolean类型的替换。
 * @param targetStr 目标字符串
 * @param obj
 * @returns string
 * @example 
 * supplant('http://ptengine.com/{id}', { id: 'x' }) => "http://ptengine.com/x"
 * supplant('http://ptengine.com/{id}', { id: true }) => "http://ptengine.com/true"
 * supplant('http://ptengine.com/{id}', { id: { a: '123' } }) => "http://ptengine.com/"
 */
export function supplant(targetStr: string, obj: any): string {
    return targetStr.replace(/{([^{}]*)}/g, (_, b) => validSupplantType.includes(typeof obj?.[b]) ? obj?.[b] : '');
}

export function encodeUnicode(str: string) {
    var res = [];
    for (var i = 0; i < str.length; i++) {
        res[i] = ('00' + str.charCodeAt(i).toString(16)).slice(-4);
    }
    return '\\u' + res.join('\\u');
}

export function decodeUnicode(str: string): string {
    str = str.replace(/\\/g, '%');
    return unescape(str);
}

export function fistLetterUpper(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
